import React from 'react';
import {Breadcrumb} from 'antd';
import './ServiceBreadcrumb.less';

const BreadcrumbItem = Breadcrumb.Item;

function ServiceBreadcrumb({path}) {
  return (
    <Breadcrumb className='ServiceBreadcrumb' separator='>'>
      {path.map((title, index) => <BreadcrumbItem key={index}>{title}</BreadcrumbItem>)}
    </Breadcrumb>
  );
}

export default ServiceBreadcrumb;


// WEBPACK FOOTER //
// ./src/routes/Service/ServiceBreadcrumb.js